module.exports = __webpack_public_path__ + "static/img/taplan.efcbedc2.png";